import { render } from "./proof_of_income_online.html?vue&type=template&id=1de40fc5&external"
import script from "./proof_of_income_online.js?vue&type=script&lang=js&external"
export * from "./proof_of_income_online.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__